document.addEventListener('DOMContentLoaded', function () {
    var yearDropdown = document.getElementById('year');
    generateOptions(yearDropdown, 1920, new Date().getFullYear());

    var monthDropdown = document.getElementById('month');
    generateOptions(monthDropdown, 1, 12);

    var dayDropdown = document.getElementById('day');
    generateOptions(dayDropdown, 1, 31);

    yearDropdown.addEventListener('change', updateDays);
    monthDropdown.addEventListener('change', updateDays);

    var form = document.getElementById('popup_create_customer');
    form.addEventListener('submit', function () {
        addBirthdayToForm();
    });
});

function generateOptions(select, start, end) {
    for (var i = start; i <= end; i++) {
        var option = document.createElement('option');
        option.value = i;
        option.innerHTML = i; // innerHTMLを設定する
        select.add(option);
    }
}

function updateDays() {
    var year = document.getElementById('year').value;
    var month = document.getElementById('month').value;
    var dayDropdown = document.getElementById('day');
    var selectedDay = dayDropdown.value; // 選択された日を保持

    dayDropdown.innerHTML = '<option value="0">日</option>';

    var maxDays = new Date(year, month, 0).getDate();
    generateOptions(dayDropdown, 1, maxDays);
    
    dayDropdown.value = selectedDay; // 選択された日を再選択
}

function addBirthdayToForm() {
    var year = document.getElementById('year').value;
    var month = document.getElementById('month').value;
    var day = document.getElementById('day').value;

    if (year !== '0' && month !== '0' && day !== '0') {
        var formattedBirthday = 'Birthday: ' + year + '-' + month + '-' + day;

        var hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = 'customer[note]';
        hiddenField.value = formattedBirthday;
        document.getElementById('popup_create_customer').appendChild(hiddenField);
    }
}
